export default function DashesTop() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="140.548"
      height="92.404"
      viewBox="0 0 140.548 92.404"
    >
      <g
        id="Group_Copy_6"
        data-name="Group Copy 6"
        transform="translate(0 29.007) rotate(-51)"
      >
        <path
          id="Fill_1_Copy_4"
          data-name="Fill 1 Copy 4"
          d="M35.346.165C31.727,3.132,28.091,6.078,24.517,9.1c-3.531,2.985-6.968,6.084-10.428,9.154-1.571,1.394-3.1,2.838-4.669,4.236-.823.732-1.631,1.474-2.493,2.157-.93.737-1.855,1.477-2.806,2.185q-1.6,1.19-3.224,2.336a1.912,1.912,0,0,0-.637.946,4.745,4.745,0,0,0-.185,2.392,3.324,3.324,0,0,0,.466,1.3c.275.383.718.7,1.177.375,2-1.4,3.962-2.863,5.9-4.366,1.642-1.278,3.19-2.685,4.752-4.065q5.125-4.529,10.405-8.873C26.3,13.952,29.886,11.1,33.457,8.226l2.837-2.281a2.206,2.206,0,0,0,.735-1.091,5.468,5.468,0,0,0,.212-2.761A3.835,3.835,0,0,0,36.7.6a1.286,1.286,0,0,0-.923-.6.674.674,0,0,0-.435.165"
          fill="#161616"
        />
        <path
          id="Fill_3_Copy"
          data-name="Fill 3 Copy"
          d="M44.119.095a.6.6,0,0,1,.372.038.677.677,0,0,1,.283.27l.16.458a3.4,3.4,0,0,1-.057,1.294,4.528,4.528,0,0,1-.94,2,1.608,1.608,0,0,1-.822.578c-.508.016-1.016.029-1.525.042-4.412.11-8.825.144-13.237.257-1.059.027-2.126.018-3.184.084l-4.035.257c-1.022.065-2.041.19-3.06.293l-1.7.172c-.409.041-.818.127-1.224.191-1.081.17-2.174.3-3.247.526l-2.178.454c-.5.1-1,.188-1.491.311-1.107.278-2.214.561-3.321.839-.552.139-1.1.323-1.645.485q-1.142.336-2.28.688c-.538.166-.844-.423-.944-.887a3.942,3.942,0,0,1,.066-1.5A5.237,5.237,0,0,1,1.2,4.632a1.858,1.858,0,0,1,.951-.669C2.675,3.8,3.2,3.638,3.729,3.485c2.127-.62,4.261-1.214,6.43-1.643l2.326-.46c.333-.066.665-.142,1-.19L17.4.626c.35-.05.7-.065,1.056-.1l2.38-.2C21.784.244,22.729.2,23.679.158c.988-.044,1.977-.114,2.966-.121L31.012.006c2.078-.015,4.157,0,6.235.009C39.536.023,41.83.018,44.119.095Z"
          transform="translate(31.03 56.589)"
          fill="#161616"
        />
        <g
          id="Group_7_Copy_2"
          data-name="Group 7 Copy 2"
          transform="translate(8.544 101.911)"
        >
          <path
            id="Clip_6"
            data-name="Clip 6"
            d="M.024.083,48.428,0,48.4,13.43,0,13.513Z"
            transform="translate(9.673 0.06) rotate(43)"
            fill="none"
          />
          <path
            id="Fill_5"
            data-name="Fill 5"
            d="M46.89,0c-2.227.155-4.451.385-6.672.6-1.076.106-2.153.2-3.228.323-1.21.136-2.431.237-3.635.411L29.8,1.851c-1.2.173-2.387.42-3.578.629-.926.163-1.839.354-2.759.549-1.032.219-2.067.426-3.1.662q-3.646.837-7.287,1.69c-2.041.479-4.094.928-6.166,1.265-1.769.287-3.54.542-5.314.793a1.206,1.206,0,0,0-.943.587A4.149,4.149,0,0,0,0,10.476a5.034,5.034,0,0,0,.3,1.791l.344.657a1.2,1.2,0,0,0,.941.584c1.228-.173,2.46-.329,3.684-.524,1.072-.171,2.153-.311,3.216-.529,1.156-.239,2.321-.451,3.471-.716l3.859-.888c1.935-.445,3.873-.885,5.818-1.289,1.189-.247,2.375-.531,3.572-.741l3.869-.681C33.29,7.4,37.543,6.931,41.791,6.433q2.546-.3,5.089-.605a1.157,1.157,0,0,0,.906-.563,3.983,3.983,0,0,0,.631-2.352,4.853,4.853,0,0,0-.293-1.72C47.95.76,47.56,0,46.942,0L46.89,0"
            transform="translate(9.675 0.066) rotate(43)"
            fill="#161616"
          />
        </g>
      </g>
    </svg>
  )
}
